import script from "./SignInButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInButton.vue?vue&type=script&setup=true&lang=ts"

import "./SignInButton.vue?vue&type=style&index=0&id=9dc357f2&lang=css"

const __exports__ = script;

export default __exports__